/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_EmptyInputs */

const cs_templates_empty = /** @type {(inputs: Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V této kategorii zatím žádné šablony.`)
};

const en_templates_empty = /** @type {(inputs: Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No templates in this category yet.`)
};

/**
* | output |
* | --- |
* | "No templates in this category yet." |
*
* @param {Templates_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty = /** @type {((inputs?: Templates_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty(inputs)
	return cs_templates_empty(inputs)
});